<template>
  <div class="page">
    <ion-grid>
      <ion-row class="search-view">
        <ion-col>
          <ion-label>User Mobile Number</ion-label>
          <div class="border-line-34 margin-top-10">
            <ion-input
            class="form-input"
            placeholder="Enter Registered Mobile No"
            type="number"
            id="userName"
            @input="userName = $event.target.value"
            :value="userName"
            maxlength="100"
            :readonly = 'readOnlyInd == true ? true : false'
            ></ion-input>
          </div>
        </ion-col>
        <ion-col>
          <br />
          <ion-button class="btn-search margin-top-10" @click="searchUserInfo" :disabled = "readOnlyInd">Search</ion-button>
          <ion-button class="btn-clear margin-top-10" @click="clearFields" >
            <ion-icon :icon="refresh"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid v-if="displayUserInfo"  class="history-list">
      <ion-row>
        <ion-col>
          <ion-label class="section-head">User Details</ion-label>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-padding-30">
          <ion-row class="ion-padding-vertical border-bottom-ion">
            <ion-col>
              <ion-label class="section-item" position="stacked">User ID</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.userId }}</div>
            </ion-col>
            <ion-col>
              <ion-label class="section-item" position="stacked">User Name</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.firstName }}</div>
            </ion-col>
            <ion-col>
              <ion-label class="section-item" position="stacked">Email</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.email}}</div>
            </ion-col>
            <ion-col>
              <ion-label class="section-item" position="stacked">state</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.state.description}}</div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <!-- <ion-col>
              <ion-label class="section-item" position="stacked">DOB</ion-label>
              <div class="section-desc margin-top-10">{{changeDateFormatWithoutTime(userInfo.DOB)}}</div>
            </ion-col> -->
            <ion-col>
              <ion-label class="section-item" position="stacked">Current Balance</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.currentAmount}}</div>
            </ion-col>
            <ion-col>
              <ion-label class="section-item" position="stacked">Available Balance</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.nettAmount}}</div>
            </ion-col>
            <ion-col>
              <ion-label class="section-item" position="stacked">GST Treatment</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.gstTreatment}}</div>
            </ion-col>
            <ion-col>
              <ion-label class="section-item" position="stacked">GST Identification Number (GSTIN)</ion-label>
              <div class="section-desc margin-top-10">{{userInfo.gstNumber}}</div>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid class="history-list" v-if="transactionsUserList.length > 0">
      <ion-row>
        <ion-col>
          <ion-label class="section-head">Payment History</ion-label>
        </ion-col>
      </ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
            <ion-col size="0.5" >
              <ion-label>S.No</ion-label>
            </ion-col>
            <ion-col size="2" >
              <ion-label>Ref.no</ion-label>
            </ion-col>
            <ion-col size="1" >
              <ion-label>Bank Ref.no</ion-label>
            </ion-col>
            <ion-col size="2" >
              <ion-label>App Ref.no</ion-label>
            </ion-col>
            <ion-col size="1" >
              <ion-label>Amount</ion-label>
            </ion-col>
            <ion-col size="2" >
              <ion-label>Remarks</ion-label>
            </ion-col>
            <ion-col size="1.5" >
              <ion-label>Payment Date</ion-label>
            </ion-col>
            <ion-col size="2" >
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />
          <ion-row class="list-item" v-for="(list, index) in this.transactionsUserList" :key="index">
            <ion-col size="12" size-md="0.5">
              <ion-label>{{ (index + 1) + ((pageNo - 1) * pageRecords) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{ list.referenceNo }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{ list.bankReference }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{ list.appReferenceNo }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{ list.amount }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{ list.remarks }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1.5">
              <ion-label>{{ changeDateFormat(list.topupDate) }}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2" >
              <ion-label class="price" v-bind:class="{'dangerColor': list.status.code == 'N' }">{{ list.status.description }}</ion-label><span v-if="list.status.code == 'N'"><ion-icon v-slot: icon-only class="edit-payment" :icon="create" @click="editUserTransaction(list)"></ion-icon></span>
            </ion-col>
          </ion-row>
          <br/>
          <ion-grid>
            <ion-row v-if="transactionsUserList.length > 0">
            <ion-col size="12" size-md="5">
              <ion-label
                class="pagination-info"
              >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
            </ion-col>
            <ion-col size="12" size-md="7" class="ion-text-right">
              <div class="pagination">
                <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                <a class="prev disabled" v-else>Prev</a>
                <a
                  v-for="page in this.pagesList"
                  :key="page"
                  v-bind:class="{'active': pageNo == page}"
                  @click="loadPage(page)"
                >{{page}}</a>
                <a
                  
                  class="next"
                  v-if="this.pageNo < this.totalPages"
                  @click="loadPage(pageNo + 1)"
                >Next</a>
                <a class="next disabled" v-else>Next</a>
              </div>
            </ion-col>
          </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info">No payment records found for the selected user</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
      <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
      </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { ToastUtils } from "../../util/toast-utils";
import { ManageUserDetails} from "../../service/evcstation/manageUser.service";
import { PaginationUtils } from "../../util/pagination-utils";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSpinner, alertController } from "@ionic/vue";
import { create, refresh } from 'ionicons/icons';
import { migratedTryParseServiceError } from "../../service";
import moment from "moment";

export default defineComponent ({
  name: 'manageUsers',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton, IonIcon, IonSpinner
  },
  data() {
    return {
      create,
      refresh,
      loaderTab: true,
      userName: "",
      userInfo: {},
      displayUserInfo: false,
      transactionsUserList: "",
      norecordsfound: false,
      totalRecords: 0,
      pageRecords: 5,
      pageNo: 1,
      pagesList: [],
      totalPages: 0,
      readOnlyInd: false,
      mobileOrEmail: "",
      manageUserDeatils: ""
    }
  },
  async mounted() {
      this.manageUserDeatils = JSON.parse(localStorage.getItem('mobileOrMail'));
      if(this.manageUserDeatils != null) {
         this.mobileOrEmail = this.manageUserDeatils.mobile;
      // alert(this.mobileOrEmail)
        this.pageNo = this.manageUserDeatils.pageNo;
      }
     
      let selecteduser = localStorage.getItem('selecteduser')

      // let page = localStorage.getItem('CPOBranchPage');

      // if (page) {
      //   this.pageNo = Number(page);
      // }

      if(this.mobileOrEmail != null && this.mobileOrEmail != '') {
        this.userName = this.mobileOrEmail;
        this.readOnlyInd = true;
        this.searchUserInfo();
      } else if(selecteduser != null) {
        this.userName = selecteduser;
        this.readOnlyInd = true;
        this.searchUserInfo();
      }
    // const fromEdit = localStorage.getItem("fromManageEdit");

    // if (fromEdit === "true") {
    //   const userInfo = localStorage.getItem("selecteduser");
    //   if (userInfo) {
    //     this.userName = userInfo;
    //     this.readOnlyInd = true;
    //     this.searchUserInfo();
    //   }
    // }
    // localStorage.removeItem("fromManageEdit");
    this.loaderTab = false;

    // let previousRouteName = this.$router.options.history.state.back;
    // if(!previousRouteName.match("/admin/reservations/reservation/")){
    //   localStorage.removeItem("mobileOrMail");
    // } 

    // let userInfo = localStorage.getItem("selecteduser");
    // if(userInfo != null) {
    //   this.userName = userInfo;
    //   if(this.userName) {
    //     // this.readOnlyInd = true;
    //     this.searchUserInfo();
    //   }
    // }
    // Migrated
    // if(this.$route.query.userName) {
    //   this.userName = this.$route.query.userName;
    //   if(this.userName) {
    //     this.readOnlyInd = true;
    //     this.searchUserInfo();
    //   }
    // }
    // this.loaderTab = false;
  },
  methods: {
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },

    changeDateFormatWithoutTime(dateValue) {
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
    },
    editUserTransaction(selectedTransaction) {
      localStorage.setItem("selectedTransaction", JSON.stringify(selectedTransaction.appReferenceNo));
      localStorage.setItem("fromManageEdit", "true");
      localStorage.setItem('selecteduser', this.userName)
      this.$router.push("manageUserEdit");
    },

    async searchUserInfo() {
      
      try {
        if (typeof this.userName === "undefined" || this.userName === null || this.userName === "" || (this.userName).toString().trim().length === 0) {
            new ToastUtils().presentToast("Enter User Name");
        } else {
          try {
            let userInfo = await new ManageUserDetails().getUserDetails(this.userName);
            this.userInfo = userInfo;
            if(Object.keys(this.userInfo).length === 0 || this.userInfo == 'Network Error') {
               this.userInfo = "";
              this.displayUserInfo = false;
              this.norecordsfound = false;
              this.transactionsUserList = [] ;
            } else {
              this.displayUserInfo = true;
              let userListResult = await new ManageUserDetails().getUserPaymentHistoryByPage(
                this.pageNo,
                this.pageRecords,
                this.userInfo.userId
              );
              if(userListResult.data.data.length != 0) {
                this.totalRecords = userListResult.data.meta.totalrecords;
                this.transactionsUserList = userListResult.data.data;
                (this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
                )),
                (this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
                ));
                this.norecordsfound = false;
                this.loaderTab = false;
                this.displayUserInfo = true;
                this.readOnlyInd = true;
            } else {
                this.transactionsUserList = [];
                this.norecordsfound = true;
                // this.displayUserInfo = false;
                this.loaderTab = false;
              }
            }
            
          } catch(error) {
            this.transactionsUserList = [];
            this.displayUserInfo = false;
            this.loaderTab = false;
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
          }
            
          // } catch(error) {
          //   alert("error")
          //   this.loaderTab = false;
          //   let serviceError = migratedTryParseServiceError(error);
          //   new ToastUtils().presentToast(serviceError.description);
          // }
          // this.userInfo = await new ManageUserDetails().getUserDetails(this.userName);
          // if(Object.keys(this.userInfo).length === 0 || this.userInfo == 'Network Error') {
          //   this.userInfo = "";
          //   this.displayUserInfo = false;
          //   this.norecordsfound = false;
          //   this.transactionsUserList = [] ;
          //   new ToastUtils().presentToast('User Name does not exist');       
          // } else {
          //     alert("er")
          //     // this.pageNo = 1;
          //     let userListResult = await new ManageUserDetails().getUserPaymentHistoryByPage(
          //       this.pageNo,
          //       this.pageRecords,
          //       this.userInfo.userId
          //     );
          //     if(userListResult.data.data.length != 0) {
          //       this.totalRecords = userListResult.data.meta.totalrecords;
          //       this.transactionsUserList = userListResult.data.data;
          //       (this.pagesList = new PaginationUtils().getPagesList(
          //       this.totalRecords,
          //       this.pageRecords,
          //       this.pageNo
          //       )),
          //       (this.totalPages = new PaginationUtils().getTotalPages(
          //       this.totalRecords,
          //       this.pageRecords
          //       ));
          //       this.norecordsfound = false;
          //       this.loaderTab = false;
          //       this.displayUserInfo = true;
          //   } else {
          //       this.transactionsUserList = [];
          //       // this.norecordsfound = true;
          //       this.displayUserInfo = false;
          //       this.loaderTab = false;
          //   }
              
          // }  
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    clearFields() {
      this.pageRecords = 5,
      this.pageNo = 1
      this.userName = null;
      document.getElementById('userName').value = null;
      this.userInfo = "";
      this.displayUserInfo = false;
      this.norecordsfound = false;
      this.transactionsUserList = []
      this.readOnlyInd = false
      
    },
    async loadPage(page) {
      try { 
        localStorage.setItem('CPOBranchPage', page);
        this.loaderTab = true;
        this.pageNo = page;
        this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            page
        );
        let manageUserDeatils = {
          mobile: this.mobileOrEmail,
          pageNo: this.pageNo
        }
        localStorage.setItem('mobileOrMail', JSON.stringify(manageUserDeatils))
        let result = await new ManageUserDetails().getUserPaymentHistoryByPage(
            this.pageNo,
            this.pageRecords,
            this.userInfo.userId
        );
        if(result.data.length != 0) {
          this.totalRecords = result.data.meta.totalrecords;
          this.transactionsUserList = result.data.data;
          (this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          this.pageNo
          )),
          (this.totalPages = new PaginationUtils().getTotalPages(
          this.totalRecords,
          this.pageRecords
          ));
          this.norecordsfound = false;
          this.loaderTab = false;
        } else {
          this.branches = [];
          this.norecordsfound = true;
          this.loaderTab = false;
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    }
  }
})
</script>

<style scoped>
.edit-payment {
  font-size: 17px;
  margin-left: 8px;
  cursor: pointer;
}
.history-list {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  opacity: 1;
  min-height: 200px;
  margin: 5px;
}

.headerSectionWrapper {
  margin-top: 20px;
  margin-bottom: 17px;
}

@media (min-width: 768px) {
  .history-list .ion-padding-30 {
    padding-left: 30px;
    padding-right: 30px;
  }

  .rp-mobile {
    display: none;
  }

  .rp-desktop {
    display: block;
  }
}

@media (max-width: 768px) {
  .rp-mobile {
    display: block;
  }
  .history-list .ion-padding-30 {
    padding-left: 15px;
    padding-right: 15px;
  }
  .rp-desktop {
    display: none;
  }
}

.border-bottom-ion p {
  margin: 5px 0;
}

.history-list .title {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto";
  color: #000000;
  opacity: 1;
}

.history-list .subtitle {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto";
  color: #000000;
  opacity: 0.5;
}

.border-bottom-ion {
  border-bottom: 1px solid #e5e5e5;
}

.history-list .dateTime {
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto";
  letter-spacing: 0;
  color: #000000;
  opacity: 0.5;
}

.history-list .price.dangerColor {
  color: #ffffff;
  background-color: #db7f7f;
  letter-spacing: 0;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 3px;
  text-align: center;
  font-size: 13px;

}

.history-list .price {
  font-size: 14px;
  letter-spacing: 0;
  font-family: "Roboto Medium";
  color: #ffffff;
  background-color: #21b24b ;
  opacity: 1;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 3px;
  text-align: center;
  font-size: 13px;

}

.headerSection {
  height: 151px;
  background: #21b24b 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
  padding: 16px;
}

.ewallet .historyTitle {
  text-align: left;
  font-size: 14px;

  font-family: "Roboto Bold";
  letter-spacing: 0;
  color: #21315d;
  opacity: 1;
  padding-left: 18px;
}

.ewallet .historyTitle.rp-desktop {
  height: 37px;
  
}

.headerSection .title {
  text-align: left;
  font-size: 15px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 0.75;
  line-height: 24px;
  margin: 0;
}

.headerSection .price {
  text-align: left;
  font-size: 26px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  margin: 0;
}

.btn-addMoney {
  height: 24px;
  position: absolute;
  --background: #21b24b !important;
  color: #ffffff;
  --background-focused: #21b24b !important;
  --background-hover: #21b24b !important;
  width: 99px;
  border-radius: 36px;
  font-size: 13px;
  font-family: "Roboto Medium";
  top: 9px;
  right: 12px;
  text-transform: capitalize;
}

.addMoney input {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 12px;
  opacity: 1;
  height: 52px;
  font-size: 14px;
  color: #000;
  padding: 12px;
}

.addMoney {
  position: relative;
  top: 15px;
}

.floatright {
  float: right;
}

.floatleft {
  float: left;
}

.clearFix {
  clear: both;
}

.pg-description{
  white-space: nowrap !important;
}
</style>